module.exports = __webpack_public_path__ + "img/496.b096c0cc.jpg";